import { memo } from "react";
import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../../theme/palette";

import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px",
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const NoCoordinatesLocationActions = memo(({ onContinue }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Button
        className={styles.blue}
        variant={"contained"}
        onClick={onContinue}
      >
        Continue
      </Button>
    </View>
  );
});
